import { Box, CircularProgress } from '@mui/material';

export const FullPageSpinner = () => (
  <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
    <CircularProgress />
  </Box>
);
